import { render, staticRenderFns } from "./studentComplier.vue?vue&type=template&id=08f3347c&scoped=true&lang=html&"
import script from "./studentComplier.vue?vue&type=script&lang=js&"
export * from "./studentComplier.vue?vue&type=script&lang=js&"
import style0 from "@/assets/less/compiler/eachend.less?vue&type=style&index=0&id=08f3347c&scoped=true&lang=less&rel=stylesheet%2Fless&"
import style1 from "./studentComplier.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f3347c",
  null
  
)

export default component.exports